// URLSearchParams patch helper for setSearchParams functional updates.
// Four map focus-mode call sites were clone-and-mutate blocks that had
// already drifted on which keys they remembered to clear — one helper,
// null deletes, string sets:
//   setSearchParams(prev => paramsPatch(prev, { track: null }), { replace: true })
//   setSearchParams(prev => paramsPatch(prev, { observation: id, walk: null }))
export function paramsPatch(
  prev: URLSearchParams,
  patch: Record<string, string | null>,
): URLSearchParams {
  const next = new URLSearchParams(prev)
  for (const [k, v] of Object.entries(patch)) {
    if (v == null) next.delete(k)
    else next.set(k, v)
  }
  return next
}
